<template>
  <div class="pagination-controls">
    <button
      class="pagination-controls__button pagination-controls__button--arrow left"
      v-on:click="prevPage"
    ></button>
    <button
      class="pagination-controls__button"
      v-bind:class="{ 'pagination-controls__button--selected': item.selected}"
      v-for="(item, index) in visibleButtons"
      v-bind:key="index"
      v-on:click="selectPage(item.label)"
    >{{ item.label }}</button>
    <button
      class="pagination-controls__button pagination-controls__button--arrow right"
      v-on:click="nextPage"
    ></button>
  </div>
</template>

<script>
export default {
  name: "PaginationControls",
  props: {
    currentPage: Number,
    totalPages: Number
  },
  data() {
    return {
      visibleButtonCount: 2
    };
  },
  methods: {
    nextPage() {
      if (this.currentPage === this.totalPages) return;

      this.selectPage(this.currentPage + 1);
    },
    prevPage() {
      if (this.currentPage === 1) return;

      this.selectPage(this.currentPage - 1);
    },
    selectPage(page) {
      this.$emit("page-change", page);
    }
  },
  computed: {
    visibleButtons() {
      var self = this;

      var totalPages = self.totalPages;
      var buttons = [];
      var buttonsToAdd = self.visibleButtonCount * 2;

      if (self.currentPage > self.totalPages) {
        return buttons;
      }

      buttons.push({
        label: self.currentPage,
        selected: true
      });

      for (let index = 1; index <= self.visibleButtonCount * 2; index++) {
        if (self.currentPage - index >= 1 && buttonsToAdd > 0) {
          buttonsToAdd--;
          buttons.unshift({
            label: self.currentPage - index,
            selected: false
          });
        }

        if (self.currentPage + index <= totalPages && buttonsToAdd > 0) {
          buttonsToAdd--;
          buttons.push({
            label: self.currentPage + index,
            selected: false
          });
        }
      }

      return buttons;
    }
  }
};
</script>

<style lang="scss">
@import "src/scss/toolkit";

.pagination-controls {
  text-align: center;
  padding: 6.25rem 0 0 0;

  // TODO: Tidy this up
  &__button {
    text-align: center;
    border: 2px solid black;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 20px;
    padding: 0;
    margin: 0 5px;
    cursor: pointer;
    transition: all calc(1s * #{var(btn-trans-speed)}) #{var(btn-trans-ease)};
    background: transparent;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;

    @include media(phab) {
      display: none;
    }

    &:hover,
    &--selected {
      background: #0179ff;
      color: #fff;
      border-color: #0179ff;

      @include media(phab) {
        display: initial;
      }
    }

    &--arrow {
      background: #666666;
      border-color: #666666;

      @include media(phab) {
        display: initial;
      }

      &.left:after {
        @extend %fonticon;
        @extend %fonticon--chevron--left--char;
        font-size: 12px;
        display: inline-block;
        color: #fff;
      }

      &.right:after {
        @extend %fonticon;
        @extend %fonticon--chevron--right--char;
        font-size: 12px;
        display: inline-block;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/PaginationControls.vue